module.exports = __webpack_public_path__ + "static/media/video.7eae7bf5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/video.mp4
// module id = 649
// module chunks = 0